const tablePagination = {
  styleOverrides: {
    root: {
      '& .MuiInputBase-input': {
        border: '1px solid #8590B3',
        borderRadius: 4,
        '&:focus': {
          borderRadius: 4
        }
      },

      '& .MuiTablePagination-selectLabel': {
        fontSize: 14
      },

      '& .MuiTablePagination-select': {
        padding: '4px 24px 4px 8px'
      },

      '& .MuiTablePagination-displayedRows': {
        fontSize: 14,
        width: 120
      }
    }
  }
};

export default tablePagination;
